var map = {
	"./icon-3d-model.svg": 4004,
	"./icon-account.svg": 2902,
	"./icon-arrow--cta-long.svg": 7919,
	"./icon-arrow--cta.svg": 6548,
	"./icon-arrow--down.svg": 6142,
	"./icon-arrow--dropdown.svg": 7465,
	"./icon-arrow--holiday.svg": 3658,
	"./icon-arrow--left.svg": 3429,
	"./icon-arrow--right.svg": 9272,
	"./icon-arrow--small.svg": 5619,
	"./icon-arrow--thick-left.svg": 5605,
	"./icon-arrow--thick-right.svg": 5400,
	"./icon-arrow--up.svg": 2421,
	"./icon-cart.svg": 8163,
	"./icon-chat.svg": 9339,
	"./icon-check--circle.svg": 4913,
	"./icon-check--sharp.svg": 6595,
	"./icon-check.svg": 139,
	"./icon-chevron--down-light.svg": 1079,
	"./icon-chevron--down.svg": 6732,
	"./icon-chevron--left.svg": 3387,
	"./icon-chevron--right--custom-color.svg": 3455,
	"./icon-chevron--right.svg": 8542,
	"./icon-chevron--thick-left.svg": 9675,
	"./icon-chevron--thick-right.svg": 8926,
	"./icon-chevron--thick-sharp-right.svg": 2733,
	"./icon-circle-checkmark.svg": 1805,
	"./icon-close--cart-confirmation.svg": 8011,
	"./icon-close.svg": 6431,
	"./icon-clothes.svg": 4807,
	"./icon-duer-logo.svg": 239,
	"./icon-lock.svg": 4696,
	"./icon-minus.svg": 223,
	"./icon-out-of-stock.svg": 9314,
	"./icon-pause--banner.svg": 225,
	"./icon-pause--white.svg": 6078,
	"./icon-pause.svg": 7805,
	"./icon-phone.svg": 2759,
	"./icon-play--banner.svg": 1531,
	"./icon-play--custom.svg": 292,
	"./icon-play--dark.svg": 5037,
	"./icon-play--orange.svg": 5239,
	"./icon-play--white.svg": 4096,
	"./icon-play.svg": 6423,
	"./icon-plus.svg": 5041,
	"./icon-remove.svg": 897,
	"./icon-return-arrows.svg": 1818,
	"./icon-return.svg": 3783,
	"./icon-reviews--5-stars.svg": 4051,
	"./icon-search.svg": 9245,
	"./icon-shipping.svg": 9251,
	"./icon-star.svg": 9041,
	"./icon-stretch-line.svg": 6819,
	"./icon-tooltip.svg": 682,
	"./icon-trail-marker.svg": 8422,
	"./icon-triangle--down.svg": 1295,
	"./icon-truck.svg": 6118,
	"./icon-zoom.svg": 4208,
	"./social-icons/icon-facebook.svg": 6102,
	"./social-icons/icon-instagram.svg": 8562,
	"./social-icons/icon-linkedin.svg": 6612,
	"./social-icons/icon-pinterest.svg": 7816,
	"./social-icons/icon-rss.svg": 2086,
	"./social-icons/icon-shopify-logo.svg": 3316,
	"./social-icons/icon-snapchat.svg": 300,
	"./social-icons/icon-tumblr.svg": 5904,
	"./social-icons/icon-twitter.svg": 5939,
	"./social-icons/icon-vimeo.svg": 1466,
	"./social-icons/icon-youtube.svg": 8457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4078;